import React from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import { debugLog } from "../../util/debug";
import { OAUTH_URL } from "../../constants/storageKeys";
import { useParams } from "react-router-dom";


export default function AuthStart() {
    const {teamsOauthUrl} = useParams();

    React.useEffect(() => {
        debugLog('Auth Start use Effect, calling initialize')
        microsoftTeams.app.initialize().then(() => {
          debugLog('initialized')
          microsoftTeams.app.getContext().then((context) => {
              const profileUrl = window.localStorage.getItem(OAUTH_URL) ?? decodeURIComponent(teamsOauthUrl);
              let authorizeEndpoint = `${profileUrl}`;
              window.location.assign(authorizeEndpoint);
            });        
        });

    }, [teamsOauthUrl])

    return(<div></div>)
}